import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(app)/support/")({
  loader: () => {
    throw redirect({
      to: "/support/contact",
    });
  },
});
